const ModalOverlayStyles = {
  backgroundColor: "rgba(0,0,0, 0.3)",
  zIndex: 10000
};

export default ModalOverlayStyles;
